import ActionsSequenceRunner from "./ActionsSequenceRunner";
import './monkeypatch-useState.js';

import AntibodySearchDatabase from "./AntibodySearchDatabase";
import AntibodySearchResults from "./AntibodySearchResults";
//import './wdyr';

import G from './Getters';

import getInitialState from './getInitialState';

import React from 'react';


import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';


import { HTML5Backend, getEmptyImage } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";

import initErrorHandler from './initErrorHandler';

import { Provider } from 'react-redux'

import ErrorBoundary from './ErrorBoundary';
//import { loadState, saveState } from './localStorage';

import AppWrapper from './AppWrapper';
import C from './Constants';
import initSession from './initSession';
import initSocket from './initSocket';

import LetterMetrics from './LetterMetrics.js';

import A from './ActionCreators';



import fetch from 'cross-fetch';


import isBrowserSupported from './browserSupportCheck';
import BrowserSupportMessage from './BrowserSupportMessage';

import { getSessionInfo, getBuildVersion, isUsingWebdriver } from './versionConfig';
import LoggingIn from './LoggingIn';

import CellCultureDesignForm from './CellCultureDesignForm';
import MicroscopyLayoutDev from './MicroscopyLayoutDev';
import Drawing from './Drawing';
import Playground from './Playground';
import TextPosition from './TextPosition';

import TemplateExpansionTest from './TemplateExpansionTest';

import WelcomeScene from './WelcomeSceneWrapper';


import SupplementPackage from "./SupplementPackage";


//import MonkeyPatcher from './MonkeyPatcher';
//MonkeyPatcher();
window.A = A;
window.G = G;

if( !Object.entries ){
  Object.prototype.entries = (obj) => {
    let vals = Object.values(obj);
    let keys = Object.keys(obj);
    return keys.map((k,ii) => ([k,vals[ii]]));
  }
}

if( !Object.fromEntries ){
  Object.fromEntries = function(entries){
    let newObj = {};
    entries.forEach(([key,val]) => {
      newObj[key] = val;
    }) 
    return newObj; 
  }
}



if( process.env.NODE_ENV === 'production' ){
  fetch('/onSiteLoad')
}

//let middlewares = [ analyticsMiddleware, thunk ];
function customFilter(action,currentState,previousHistory){
  //debugger;
}

//console.log("initialState");
//console.log(INITIAL_STATE)

let remoteDevTools = false;
if( process.env.NODE_ENV !== 'production' ){
  remoteDevTools = true;
  window.__TESTING_ERROR = true;
}



let initialState;
if( true /* process.env.NODE_ENV !== 'production'*/ ){
  initialState = getInitialState();
}



let websocketTarget;
if( window.location.origin.includes('localhost') ){
  websocketTarget = "http://0.0.0.0:80"
}else{
  websocketTarget = window.location.origin;
}

function getCookieMap(){
  let map = Object.fromEntries(
    document.cookie.split('; ').map(x => x.split('='))
  )
  return map;
}


//let cookieMap = getCookieMap();
let personId = (getCookieMap().personId);

if( process.env.NODE_ENV === 'development' ){
  personId = "dev";
}

console.log({personId});

if (!navigator.userAgent.includes("Chrome")) {
  //alert("User is NOT using Chrome");
}


let session = initSession({
  initialState,//:undefined,
  remoteDevTools,
  websocketTarget,
  personId,
});

let wsArgs = { remoteDevTools, websocketTarget, personId };


let shouldCreateSocket = true;

if( process.env.NODE_ENV !== 'production' ){
  //have this here to maybe speed up UI tests?
  //most of them don't need to establish a websocket connection
  if( window.__testMeta ){
    shouldCreateSocket = false;
  }
}

if( shouldCreateSocket ){
  session.store.dispatch(initSocket(wsArgs));
  //session.socket = initSocket(session.store,wsArgs);
}

let { store } = session;

//store.dispatch(A.launchTutorial())


if( process.env.NODE_ENV !== 'production' ){
  window.__reduxStore = store;
  window.__actionCreators = A; 
}


let route = document.URL.split('/')[3];
let path = route !== '' ? route : '';

store.dispatch( A.initSession(path) );
//store.dispatch( A.fetchThreads() );

if( process.env.NODE_ENV !== 'production' ){

  //store.dispatch(A.setUiMode({mode:"FIGURES_AND_PANELS", modeArgs:{ _id:"fp0", figurePanelId:"fp0" }}));

  if( !isUsingWebdriver() ){

    /*
  window.__invoke = () => {}
  */
  }

}



window.__sendEvents = function(){
  store.dispatch( A.sendDomEvents() );
}

/*store.dispatch(
  A.initSession()
)*/

window.__hookTrace = { useState:null };

window.__setState = state => {
  store.dispatch(A.setState({state}));
}

window.onbeforeunload = function(){
  return false;//!document.location.href.includes('localhost')
}

window.addEventListener('beforeunload',() => {
  if( window.__streamEvents ){
    window.__streamEvents();
  }

  store.dispatch(A.endSession());
})




if( !process.env.REACT_APP_BUILD_VERSION ){
  throw Error("No build version provided.");
}

if( process.env.NODE_ENV !== 'production' ){
  window.__sciugoMocks = {
    ".*s3.*aws":{body:'<xml></xml>',options:{status:500}}
  };

}

const handleError = initErrorHandler(store);

window.addEventListener('error',handleError)
window.addEventListener('unhandledrejection',handleError)

if( process.env.NODE_ENV !== 'production' ){
  if( isUsingWebdriver() ){
    window.addEventListener('mousemove',function(e){
      let nativeEvent = e.nativeEvent;
      //console.log([e.clientX,e.clientY]);
      let div = document.createElement("DIV");
      div.style['pointer-events'] = 'none';
      div.style.width = '5px';
      div.style.height = '5px';
      div.style.background = 'lime';
      div.style.position = 'fixed';
      div.style.top = ''+e.clientY+'px';
      div.style.left = ''+e.clientX+'px';
      div.id = 'mouse-tracker';
      div.style['z-index'] = '1000000';

      let currentTracker = document.querySelector('#mouse-tracker');
      if( currentTracker ){
        currentTracker.parentNode.removeChild(currentTracker);
      }
      document.body.appendChild(div);
    })
  }
}



window.el = () => {
  let htmlEl = window.$0
  let reactCompName = htmlEl[Object.keys(htmlEl).find(x => x.includes('Fiber'))]._debugOwner.type.name
  console.log(htmlEl);
  console.log(reactCompName);
}


window.__errorHandler = handleError;


window.blobToDataString = function(blobPath){
  fetch(blobPath).then(r => r.text()).then(console.log);
}

let browserSupport;
try{
  browserSupport = isBrowserSupported();
  browserSupport = { supported:true };
  if( !Object.fromEntries ){
    browserSupport = { supported:false, agent:'Unknown browser, you may need to update your browser.' };
  }
}catch{
  browserSupport = { supported:false, agent:"Unknown browser, you may need to update your browser." }
}

let toRender = browserSupport.supported ? <AppWrapper key={Math.random()}/> : <BrowserSupportMessage browserSupport={browserSupport}/> 


//addImages(store);

if( !isUsingWebdriver() ){
  //toRender = ( <MicroscopyCropInsertion {...{ figurePanelId:"micro-figure", cellLocation:[3,1] }}/>);
}

//toRender = <AntibodySearchDatabase/>


//toRender = <Publications/>

//toRender = <TimelineBuilder/>
//toRender = <RelationshipSearch/>

//toRender = <Playground/>

//toRender = <Drawing/>

//toRender = <ColorProjection/>

//toRender = <WelcomeScene/>
//toRender = <SamplePlots/>
//toRender = <SupplementPackage/>
//toRender = <MembraneGroupContainer/>

// toRender = <LoggingIn />

//toRender = <Playground/>

// toRender = <TextPosition />

/*toRender = (

  <div class="sg-row">
    <ItemSearch/>
    <WesternBlotWorkspace/>
  </div>
)*/

let wrapErrBound = false;
if ( wrapErrBound ){
  toRender = (
    <ErrorBoundary>
      {toRender}
    </ErrorBoundary>
  )
}

let actionSequence;

if( process.env.NODE_ENV === "development" ){
  actionSequence = (

    <div class="br-overlay">
          <ActionsSequenceRunner items={[
            {action:A.tryLogout({force:true}), label:"Logout"},
            {action:A.tryLogin({email:"jonahlibrach@gmail.com",password:"jonahlibrach"}),label:"Login jonah"},
            {action:A.createItem({
              type:"directories",
              inTopLevelParent:"imageSets"
            }), label:"Create I&U dir"},
            { action:A.syncChanges(), label:"Save" },

              {action:A.tryLogout({force:true}), label:"Logout"},


              {action:A.tryLogin({email:"jonah@blottinginnovations.com",password:"Mesowestern#23"}),
                label:"Login Jonah 2"
              },
                

              {action:A.createItem({
              type:"directories",
              inTopLevelParent:"imageSets"
            }), label:"Create I&U dir"},
            { action:A.syncChanges(), label:"Save" },

            {action:A.tryLogout({force:true}), label:"Logout"},


            {action:A.tryLogin({email:"jonahlibrach@gmail.com",password:"jonahlibrach"}),label:"Login jonah"},



          ]}/>
        </div>

  )
}



ReactDOM.render(
  <Provider store={store}>
    <DndProvider backend={HTML5Backend}>
      <React.StrictMode>
        {toRender}
        {false && actionSequence}
      </React.StrictMode>
    </DndProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
